module.exports = __webpack_public_path__ + "img/Xirong_Li@2x.a0a0dc16.png";